import {styled} from '@mui/system';

export const InfoField = styled('div')(({theme}) => ({
  svg: {
    marginRight: '1rem',
    color: theme.palette.common.swatch['60'],
  },
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: '1rem',
}));
